import { PaymentMethod } from 'types';
import { hasValidationError } from './hasValidationError';

type NormalizeMethodKeyFn = (methodType: string) => string;

interface GetFirstMethodWithErrorArgs {
  isCombinedPaymentsEnabled: boolean;
  methodsWithErrors: string[];
  normalizeFn: NormalizeMethodKeyFn;
  paymentMethodScrollOrder: string[];
  selectedPaymentMethodType: string | null;
}

export const normalizeMethodKeyForError = (methodType: string): string => {
  if (methodType === PaymentMethod.CREDIT_CARD) {
    return 'credit_card_1';
  }

  return methodType;
};

export const getMethodsWithErrors = (
  errors: Record<string, unknown>,
  normalizeFn: NormalizeMethodKeyFn
): string[] => {
  const methodErrors = errors?.methods;

  if (!methodErrors || typeof methodErrors !== 'object') {
    return [];
  }

  const methodKeysWithErrors = Object.keys(methodErrors).filter((key) =>
    hasValidationError(methodErrors[key])
  );

  return methodKeysWithErrors
    .map(normalizeFn)
    .filter(
      (methodKey, index, normalizedMethods) =>
        normalizedMethods.indexOf(methodKey) === index
    );
};

export const getFirstMethodWithError = ({
  isCombinedPaymentsEnabled,
  methodsWithErrors,
  normalizeFn,
  paymentMethodScrollOrder,
  selectedPaymentMethodType,
}: GetFirstMethodWithErrorArgs): string => {
  if (!methodsWithErrors.length) {
    return null;
  }

  if (!isCombinedPaymentsEnabled) {
    if (selectedPaymentMethodType) {
      const selectedMethod = normalizeFn(selectedPaymentMethodType);

      if (methodsWithErrors.includes(selectedMethod)) {
        return selectedMethod;
      }
    }

    return methodsWithErrors[0];
  }

  return (
    paymentMethodScrollOrder.find((methodKey) =>
      methodsWithErrors.includes(normalizeFn(methodKey))
    ) || methodsWithErrors[0]
  );
};
